import { combineReducers } from 'redux';

import { State } from '../types';
import businessInfo from './business-info';
import businessTypes from './business-types';

const appState = combineReducers<State>({
  businessInfo,
  businessTypes,
});

export default appState;
